import { render, staticRenderFns } from "./ModalRadioRecliner.vue?vue&type=template&id=d4f8fb64"
import script from "./ModalRadioRecliner.vue?vue&type=script&lang=js"
export * from "./ModalRadioRecliner.vue?vue&type=script&lang=js"
import style0 from "./ModalRadioRecliner.vue?vue&type=style&index=0&id=d4f8fb64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports